import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";

export default function* contractStatusesList(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, "contract-statuses");

    yield put({
      type: Constants.GLOBAL_CONTRACT_STATUSES_LIST_SUCCESS,
      payload: {
        contractStatuses: {...res.data}
      }
    });

  } catch (err) {
    // should signout user if entity could not be loaded
    yield put({
      type: Constants.PAGE_SIGNOUT_START
    });
    
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchContractStatusesList() {
  yield takeEvery(Constants.GLOBAL_CONTRACT_STATUSES_LIST, contractStatusesList);
}
